import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import scrollToComponent from 'react-scroll-to-component';

import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({}, commonActionCreators);

class Designers extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

		this.state = {
			logoBlock: null,
			bandBlock: null,
		}
	}

	componentWillMount() {
		document.title = 'Diamonds Direct Designers';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
	}

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  userNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  scrollToBlock() {

  	let target = this.controlBlock;
  	if(this.state.logoBlock === 'engagement') {
  		target = this.engagementBlock;
  	} else if(this.state.logoBlock === 'band') {
  		target = this.bandBlock;
  	} else if(this.state.logoBlock === 'jewelry') {
  		target = this.jewelryBlock;
  	}

  	setTimeout(() => {
	    scrollToComponent(target, {
	      offset: -200, 
	      align: 'top', 
	      duration: 1000, 
	      ease: 'inOutCube',
	    });
  	}, 400);
  }

  scrollToBand() {

  	let target = this.bandBlock;
  	if(this.state.bandBlock === 'hers') {
  		target = this.herBlock;
  	} else if(this.state.bandBlock === 'his') {
  		target = this.hisBlock;
  	}

  	setTimeout(() => {
	    scrollToComponent(target, {
	      offset: -200, 
	      align: 'top', 
	      duration: 1000, 
	      ease: 'inOutCube',
	    });
  	}, 400);
  }

  toggleLogoBlock(key) {
  	if(this.state.logoBlock == key) {
  		this.setState({ logoBlock: null, bandBlock: null }, () => {
  			this.scrollToBlock();
  		});
  	} else {
  		this.setState({ logoBlock: key, bandBlock: null }, () => {
  			this.scrollToBlock();
  		});
  	}
  }

  toggleBandBlock(key) {
  	if(this.state.bandBlock == key) {
  		this.setState({ bandBlock: null }, () => {
  			this.scrollToBand();
  		});
  	} else {
  		this.setState({ bandBlock: key }, () => {
  			this.scrollToBand();
  		});
  	}
  }

	render() {
		return <div className='Designers'>
			
			<div className='designersHeader' onClick={() => this.internalNav('designer/diamonds-direct-designs')}>
				<img className='desktopOnly' src='https://ddw2.diamondsdirect.com/img/designers/newdddbanner_c.jpg' />
				<img className='mobileOnly' src='https://ddw2.diamondsdirect.com/img/designers/newdddbanner_mobile.jpg' />
			</div>

			<div className='dddBanner' style={{display: 'none'}}>
				<div className='dddLogoSide'>
					<div className='dddLogoWrapper'>
						<img src='https://ddw2.diamondsdirect.com/img/designers/dddlogo.svg' />
					</div>
					<div className='dddTextWrapper'>Introducing our exclusive line of classic and modern jewelry. Only from Diamonds Direct.</div>
				</div>
				<div className='dddImageSide'>
					<img src='https://ddw2.diamondsdirect.com/img/designers/rings.png' />
				</div>
			</div>

			<div className='displayBlock'>
				<div className='controlsWrapper' ref={(div) => { this.controlBlock = div; }}>
					<div 
						className={this.state.logoBlock == 'engagement' ? 'controlButton selected' : 'controlButton'} 
						onClick={() => this.toggleLogoBlock('engagement')}>
						<div className='textWrapper'>See Engagement<br />Ring Designers</div>
						<div className='arrowWrapper'>
							<div className='arrowDown'></div>
							<div className='arrowUp'></div>
						</div>
					</div>
					<div 
						className={this.state.logoBlock == 'band' ? 'controlButton selected' : 'controlButton'} 
						onClick={() => this.toggleLogoBlock('band')}>
						<div className='textWrapper'>See Wedding<br />Band Designers</div>
						<div className='arrowWrapper'>
							<div className='arrowDown'></div>
							<div className='arrowUp'></div>
						</div>
					</div>
					<div 
						className={this.state.logoBlock == 'jewelry' ? 'controlButton selected' : 'controlButton'} 
						onClick={() => this.toggleLogoBlock('jewelry')}>
						<div className='textWrapper'>See Fine Jewelry<br />Designers</div>
						<div className='arrowWrapper'>
							<div className='arrowDown'></div>
							<div className='arrowUp'></div>
						</div>
					</div>
				</div>
				<div className='displayWrapper'>

					<div className={this.state.logoBlock == 'engagement' ? 'ringDesignersWrapper toggleElement open' : 'ringDesignersWrapper toggleElement'} ref={(div) => { this.engagementBlock = div; }}>
						<div className='logosWrapper'>
							<div className='logoElement' onClick={() => this.internalNav('designer/simon-g-jewelry')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/simong.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/verragio')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/verragio.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/christopher-designs')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/christopher.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/henri-daussi')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/daussi.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/tacori')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/c-gonshor')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/gonshor.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/fana')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/fana.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/artcarved')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/artcarved.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/diamonds-direct-designs')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/dddesigns.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/ses')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/ses.svg' />
							</div>
							<div className={'logoElement'} onClick={() => this.internalNav('designer/classique')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/classique.svg' />
							</div>
							<div className={'logoElement'} onClick={() => this.internalNav('designer/coast-diamond')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/coast.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/sylvie-collection')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/sylvie.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/michael-m')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/michaelm2.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/a-jaffe')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/ajaffe.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/jack-kelege')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/kelege.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/uneek')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/uneek.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/kirk-kara')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/kirkkara.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/jeff-cooper')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/jeffcooper.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/amden')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/amden.jpg' />
							</div>
						</div>
						<div className='closeIcon'>
							<div className='arrowWrapper'>
								<div className='closeArrow' onClick={() => this.toggleLogoBlock(null)}></div>
							</div>
						</div>
					</div>

					<div className={this.state.logoBlock == 'band' ? 'bandDesignersWrapper toggleElement open' : 'bandDesignersWrapper toggleElement'} ref={(div) => { this.bandBlock = div; }}>
						<div className='bandsControlWrapper'>
							<div 
								className={this.state.bandBlock == 'hers' ? 'bandControlButton selected' : 'bandControlButton'} onClick={() => this.toggleBandBlock('hers')}>
								<div className='bandButtonText'>Bands for Her</div>
								<div className='bandButtonImage'>
									<img src='https://ddw2.diamondsdirect.com/img/designers/herband.png' />
								</div>
							</div>
							<div 
								className={this.state.bandBlock == 'his' ? 'bandControlButton selected' : 'bandControlButton'} onClick={() => this.toggleBandBlock('his')}>
								<div className='bandButtonText'>Bands for Him</div>
								<div className='bandButtonImage'>
									<img src='https://ddw2.diamondsdirect.com/img/designers/himband.png' />
								</div>
							</div>
						</div>
						<div className={this.state.bandBlock == 'hers' ? 'herBandsWrapper bandToggleElement open' : 'herBandsWrapper bandToggleElement'} ref={(div) => { this.herBlock = div; }}>
							<div className='logosWrapper'>
								<div className='logoElement' onClick={() => this.internalNav('designer/simon-g-jewelry')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/simong.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/verragio')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/verragio.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/christopher-designs')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/christopher.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/henri-daussi')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/daussi.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/tacori')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/c-gonshor')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/gonshor.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/fana')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/fana.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/artcarved')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/artcarved.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/diamonds-direct-designs')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/dddesigns.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/ses')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/ses.svg' />
								</div>
								<div className={'logoElement'} onClick={() => this.internalNav('designer/classique')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/classique.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/true-romance')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/trueromance.jpg' />
								</div>
								<div className={'logoElement'} onClick={() => this.internalNav('designer/coast-diamond')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/coast.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/sylvie-collection')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/sylvie.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/michael-m')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/michaelm2.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/a-jaffe')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/ajaffe.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/jack-kelege')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/kelege.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/uneek')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/uneek.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/kirk-kara')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/kirkkara.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/novell')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/novell.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/jeff-cooper')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/jeffcooper.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/amden')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/amden.jpg' />
								</div>
								<div className={'logoElement'} onClick={() => this.internalNav('designer/benchmark')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/benchmark.svg' />
								</div>
							</div>
							{this.state.bandBlock !== null ?
								<div className='closeIcon'>
									<div className='arrowWrapper'>
										<div className='closeArrow' onClick={() => this.toggleBandBlock(null)}></div>
									</div>
								</div> :
								null
							}
						</div>
						<div className={this.state.bandBlock == 'his' ? 'hisBandsWrapper bandToggleElement open' : 'hisBandsWrapper bandToggleElement'} ref={(div) => { this.hisBlock = div; }}>
							<div className='logosWrapper'>
								<div className='logoElement' onClick={() => this.internalNav('designer/simon-g-jewelry')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/simong.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/verragio')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/verragio.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/henri-daussi')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/daussi.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/tacori')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/artcarved')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/artcarved.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/diamonds-direct-designs')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/dddesigns.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/true-romance')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/trueromance.jpg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/furrer-jacot')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/furrerjacot.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/christian-bauer')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/bauer.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/michael-m')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/michaelm2.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/a-jaffe')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/ajaffe.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/novell')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/novell.svg' />
								</div>
								<div className='logoElement' onClick={() => this.internalNav('designer/jeff-cooper')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/jeffcooper.svg' />
								</div>
								<div className={'logoElement'} onClick={() => this.internalNav('designer/per-amore')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/peramore.svg' />
								</div>
								<div className={'logoElement'} onClick={() => this.internalNav('designer/benchmark')}>
									<img src='https://ddw2.diamondsdirect.com/img/designers/logos/benchmark.svg' />
								</div>
							</div>
							{this.state.bandBlock !== null ?
								<div className='closeIcon'>
									<div className='arrowWrapper'>
										<div className='closeArrow' onClick={() => this.toggleBandBlock(null)}></div>
									</div>
								</div> :
								null
							}
						</div>
						{this.state.bandBlock === null ?
							<div className='closeIcon'>
								<div className='arrowWrapper'>
									<div className='closeArrow' onClick={() => this.toggleLogoBlock(null)}></div>
								</div>
							</div> :
							null
						}
					</div>

					<div className={this.state.logoBlock == 'jewelry' ? 'jewelryDesignersWrapper toggleElement open' : 'jewelryDesignersWrapper toggleElement'} ref={(div) => { this.jewelryBlock = div; }}>
						<div className='logosWrapper'>
							<div className='logoElement' onClick={() => this.internalNav('designer/simon-g-jewelry')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/simong.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/christopher-designs')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/christopher.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/tacori')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/tacori.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/fana')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/fana.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/diamonds-direct-designs')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/dddesigns.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/ses')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/ses.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/michael-m')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/michaelm2.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/jack-kelege')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/kelege.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/mastoloni')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/mastoloni.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/uneek')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/uneek.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/pejay')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/pejay.svg' />
							</div>
							<div className='logoElement' onClick={() => this.internalNav('designer/amden')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/amden.jpg' />
							</div>
							<div className={'logoElement'} onClick={() => this.internalNav('designer/odelia')}>
								<img src='https://ddw2.diamondsdirect.com/img/designers/logos/odelia.jpg' />
							</div>
						</div>
						<div className='closeIcon'>
							<div className='arrowWrapper'>
								<div className='closeArrow' onClick={() => this.toggleLogoBlock(null)}></div>
							</div>
						</div>
					</div>

				</div>
			</div>




			<div className='premierBanner' style={{display: 'none'}}>
				<div className='bannerHeader'>
					<div className='textWrapper'>Our Premier Brands</div>
					<div className='underlineWrapper'></div>
				</div>
				<div className='elementWrapper'>
					<div className={'premierElement ddd'} onClick={() => this.userNav('instantsearchplus/result/?q=diamonds%20direct%20designs')}>
						<img src='https://ddw2.diamondsdirect.com/img/designers/dddlogo.svg' />
					</div>
					<div className={'premierElement tacori'} onClick={() => this.userNav('designersbioprod/?dsgnr=Tacori&typ=Bridal')}>
						<img src='https://ddw2.diamondsdirect.com/img/designers/tacorilogo.svg' />
					</div>
					<div className={'premierElement christopher'} onClick={() => this.userNav('designersbioprod/?dsgnr=Christopher+Designs&typ=Bridal')}>
						<img src='https://ddw2.diamondsdirect.com/img/designers/christopherlogo.svg' />
					</div>
					<div className={'premierElement verragio'} onClick={() => this.userNav('designersbioprod/?dsgnr=Verragio&typ=Bridal')}>
						<img src='https://ddw2.diamondsdirect.com/img/designers/verragiologo.svg' />
					</div>
					<div className={'premierElement henriDaussi'} onClick={() => this.userNav('designersbioprod/?dsgnr=Henri+Daussi&typ=Bridal')}>
						<img src='https://ddw2.diamondsdirect.com/img/designers/daussilogo.svg' />
					</div>
					<div className={'premierElement simonG'} onClick={() => this.userNav('designersbioprod/?dsgnr=Simon+G.&typ=Bridal')}>
						<img src='https://ddw2.diamondsdirect.com/img/designers/simonglogo.svg' />
					</div>
				</div>
			</div>
			<div className='bridalBanner' style={{display: 'none'}}>
				<div className='bannerHeader'>
					<div className='textWrapper'>Bridal Designers</div>
					<div className='underlineWrapper'></div>
				</div>
				<div className='bannerSubheader'>For the most important day of your life.</div>
				<div className='linksWrapper'>
					<div className='linkColumn'>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=A.Jaffe&typ=Bridal')}>A. Jaffe</div>
						<div className='designerLink' onClick={() => this.userNav('amden')}>Amden</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=ArtCarved&typ=Bridal')}>Artcarved</div>
						<div className={'designerLink noLink'}>Benchmark</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Coast&typ=Bridal')}>Coast</div>
						<div className='designerLink' onClick={() => this.userNav('instantsearchplus/result/?q=diamonds%20direct%20designs')}>DD Designs</div>
						<div className='designerLink' onClick={() => this.userNav('fana')}>Fana</div>
						<div className='designerLink' onClick={() => this.userNav('furrer-jacot')}>Furrer Jacot</div>
					</div>
					<div className='linkColumn'>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Jeff+Cooper&typ=Bridal')}>Jeff Cooper</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Kirk+Kara&typ=Bridal')}>Kirk Kara</div>
						<div className='designerLink' onClick={() => this.userNav('michael-m')}>Michael M</div>
						<div className='designerLink' onClick={() => this.userNav('novell')}>Novell</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Sylvie&typ=Bridal')}>Sylvie</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Tacori&typ=Bridal')}>Tacori</div>
						<div className='designerLink' onClick={() => this.userNav('true-romance')}>True Romance/Paul</div>
						<div className={'designerLink noLink'}>Winston</div>
					</div>
					<div className='linkColumn'>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Christian+Bauer&typ=Bridal')}>Christian Bauer</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Christopher+Designs&typ=Bridal')}>Christopher Designs</div>
						<div className={'designerLink noLink'}>Classique</div>
						<div className={'designerLink noLink'}>Per Amore</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Gottlieb&typ=Bridal')}>Gottlieb</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Henri+Daussi&typ=Bridal')}>Henri Daussi</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Jack+Kelege&typ=Bridal')}>Jack Kelege</div>
						<div className={'designerLink fourRow'}>&nbsp;</div>
					</div>
					<div className='linkColumn'>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Verragio&typ=Bridal')}>Verragio</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=C.+Gonshor&typ=Bridal')}>C. Gonshor</div>
						<div className={'designerLink noLink'}>Gabriel</div>
						<div className='designerLink' onClick={() => this.userNav('pejay')}>PeJay</div>
						<div className={'designerLink'} onClick={() => this.userNav('designersbioprod/?dsgnr=Uneek&typ=Bridal')}>Uneek</div>
						<div className='designerLink' onClick={() => this.userNav('ses')}>SES</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Simon+G.&typ=Bridal')}>Simon G</div>
						<div className={'designerLink fourRow'}>&nbsp;</div>
					</div>
				</div>
			</div>
			<div className='fashionBanner' style={{display: 'none'}}>
				<div className='bannerHeader'>
					<div className='textWrapper'>Fashion Designers</div>
					<div className='underlineWrapper'></div>
				</div>
				<div className='bannerSubheader'>A jewelry piece for any occasion.</div>
				<div className='linksWrapper'>
					<div className='linkColumn'>
						<div className='designerLink' onClick={() => this.userNav('amden')}>Amden</div>
						<div className='designerLink' onClick={() => this.userNav('fana')}>Fana</div>
						<div className={'designerLink noLink'}>Gabriel</div>
						<div className={'designerLink fourRow'} onClick={() => this.userNav('designersbioprod/?dsgnr=Henri+Daussi&typ=Bridal')}>Henri Daussi</div>
					</div>
					<div className='linkColumn'>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Jack+Kelege&typ=Bridal')}>Jack Kelege</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Mastoloni&typ=Fashion')}>Mastoloni</div>
						<div className='designerLink' onClick={() => this.userNav('michael-m')}>Michael M</div>
						<div className={'designerLink fourRow'}>&nbsp;</div>
					</div>
					<div className='linkColumn'>
						<div className={'designerLink noLink'}>Odelia</div>
						<div className='designerLink' onClick={() => this.userNav('pejay')}>PeJay</div>
						<div className='designerLink' onClick={() => this.userNav('ses')}>SES</div>
						<div className={'designerLink fourRow'}>&nbsp;</div>
						<div className={'designerLink twoRow'} onClick={() => this.userNav('designersbioprod/?dsgnr=Henri+Daussi&typ=Bridal')}>Henri Daussi</div>
					</div>
					<div className='linkColumn'>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Simon+G.&typ=Bridal')}>Simon G</div>
						<div className='designerLink' onClick={() => this.userNav('designersbioprod/?dsgnr=Tacori&typ=Bridal')}>Tacori</div>
						<div className={'designerLink'} onClick={() => this.userNav('designersbioprod/?dsgnr=Uneek&typ=Bridal')}>Uneek</div>
						<div className={'designerLink fourRow'}>&nbsp;</div>
					</div>
				</div>
			</div>
			<div className='bottomWrapper'>
				<div className='bottomBlock'>
					<div className='halfBlock' onClick={() => this.internalNav('custom-design')}>
						<img src='https://ddw2.diamondsdirect.com/img/designers/custom.jpg' />
					</div>
					<div className='halfBlock' onClick={() => this.openNew('https://diamondsdirecttimepieces.com/')}>
						<img src='https://ddw2.diamondsdirect.com/img/designers/watch.jpg' />
					</div>
				</div>
				<div className='bottomBlock' onClick={() => this.internalNav('appointments')}>
					<div className='fullBlock'>
						<img src='https://ddw2.diamondsdirect.com/img/designers/instore.jpg' />
						<div className='imgOverlay'>
							<div className='overlayTitle'>See a Designer in Store</div>
							<div className='overlaySubtitle'>Click Here to Make an Appointment</div>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}
export default Designers;

function mapStateToProps(state) {
  return {
    common: state.common,
    header: state.header,
  };
}

export const DesignersContainer = connect(
  mapStateToProps,
  allActionCreators
)(Designers);


// WEBPACK FOOTER //
// ./src/components/views/designers/Designers.jsx